import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { CallProvider } from "../state/CallProvider";
import { Softphone } from "./Softphone";
import "./cti.css";

createRoot(document.getElementById("softphone")!).render(
  <StrictMode>
    <CallProvider>
      <Softphone />
    </CallProvider>
  </StrictMode>,
);
